import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  IconButton,
  Select,
  MenuItem,
  Box
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export default function ChangeStatusModal({ open, onClose, data }) {
  const [newStatus, setNewStatus] = useState(data?.status || 'active');

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          bgcolor: '#3F90DF',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Update Account Status
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: '#161C24', pt: 4 }}>
        <Box sx={{ mt: 3 }}>
          <FormControl fullWidth>
            <InputLabel sx={{ color: '#9CA3AF' }}>Select Status</InputLabel>
            <Select
              value={newStatus}
              label="Select Status"
              onChange={(e) => setNewStatus(e.target.value)}
              sx={{ color: '#fff', '& fieldset': { borderColor: '#333' } }}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="deleted">Deleted</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ bgcolor: '#161C24', p: 3, borderTop: '1px solid #333' }}>
        <Button onClick={onClose} sx={{ color: '#9CA3AF' }}>
          Close
        </Button>
        <Button variant="contained" sx={{ bgcolor: '#3F90DF' }}>
          Save Status
        </Button>
      </DialogActions>
    </Dialog>
  );
}
